export const legalFormOptions = [
    "AG",
    "e.K.",
    "Einzelunternehmen",
    "GbR",
    "GmbH",
    "OHG",
    "e.V.",
    "e.G.",
    "UG",
    "GmbH&Co. KG.",
];
